// ... other imports ...

import styled from 'styled-components';
import React,{ useState } from 'react';
import Pic from 'assets/images/People.png'
import { words} from '../translations'

const Screen1 = ({title,language}) =>{

    return (
        <Text>
        {words['intro1-0'][language]} 
        <Image src={Pic} alt="Image description" />
       {words['intro1-1'][language]} <Highlight>{words['intro1-2'][language]}</Highlight> {words['intro1-3'][language]}, <Bold>{words['intro1-4'][language]}</Bold>.

        </Text>
    )
}

export default Screen1

const Text = styled.div`
font-weight: 500;
font-size: 44px;
line-height: 1.4;
color: #2A3039;

@media (max-width: 768px) {
    font-size: 38px;
}
`

const Image = styled.img`
    width:162px;
    display: inline;
    vertical-align: middle;
    margin-left: 0.25em;
    margin-right: 0.25em;
`

const InlineWrapper = styled.span`
  display: inline-flex;
  align-items: center;
`;

const Highlight = styled.span`
background: #EBF1FD;
border-radius: 40px;
padding:0px 16px;
margin:0px -8px;

`

const Bold = styled.span`
    font-weight:600;
    color:#2D70E2;
`
